<template>
	<div>
		<!-- 产品单位 -->
		<div class="nav_box">
			<el-button @click="adddata">
				添加产品单位
			</el-button>
		</div>
		<!--  -->
		<div class="table_box" v-loading="table_loading" >
			<!--  -->
			<!-- datapage check_list  -->
			<tabcontainer
			:ischecks="false"
			:surplus="700"
			:list.sync="datapage.list"
			:total.sync="datapage.total"
			:pagesize.sync="datapage.pagesize"
			:page.sync="datapage.page"
			@retucheck="(e)=>{check_list = e.val}"
			@changesize="modify_pagesize"
			@changepage="switch_page"
			>
				<!--  -->
				<template slot="body">
					<!--  -->
					<!-- <el-table-column align="center" type="selection" fixed width="50"></el-table-column> -->
					<!--  -->
					<el-table-column show-overflow-tooltip
					 :width="item.width"
					 :prop="item.prop" :label="item.name" 
					 v-for="(item, index) in tableColumn">
					 
					 <template v-slot="scope" v-if="index == 2">
					 	<span class="Viewspan" @click="editdata(scope.row)">
					 		编辑
					 	</span>
						<span class="delspan" @click="deldata(scope.row)">
							删除 
						</span>
					 </template>
					</el-table-column>
					<!--  -->
				</template>
				<!--  -->
				<!--  -->
				<!-- <template slot="tabtns">
					<el-button @click="custom_click(1)" class="color1" :disabled="check_list.length == 0">
						批量删除
					</el-button>
				</template> -->
				<!--  -->
			</tabcontainer> 
			<!--  -->
		</div>
		<!--  -->
		<!--  -->
		<defdialog :show.sync="dialogshow" :title="dialogtitle" width="600px">
			<span slot="body">
				<el-form ref="form" label-width="80px">
					<el-form-item label="单位名称">
						<el-input clearable v-model="dialoginfo.name" maxlength="100"  ></el-input>
					</el-form-item>
					<el-form-item label="单位排序">
						<el-input clearable type="number" 
						placeholder="默认100"
						v-model="dialoginfo.sort" maxlength="10" ></el-input>
					</el-form-item>
				</el-form>
			</span>
			<div slot="footer">
				<el-button type="primary" @click="category_save">保 存</el-button>
				<el-button @click="category_close">取 消</el-button>
			</div>
		</defdialog>
		<!--  -->
		
		
		
	</div>
</template>

<script>
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	import defdialog from "@/components/content/dialog/defdialog.vue"
	import {
		handlereq,
		alertMess,
		try_catch,
	} from 'network/kh_public'
	
	import {
		add_goods_unit,
		del_goods_unit,
		edit_goods_unit,
		get_goods_unit_list, 
	} from "./js/goods.js"
	
	export default {
		components: {
			tabcontainer,
			defdialog,
		},
		data() { 
			return {
			
				
				
				dialogshow: false,
				dialogtitle: '添加产品单位',
				dialoginfo: {
					name: '',
					sort: '',
				},
				edit_flag: false,
				edit_id: '',
				
				table_loading: false,
				datapage: {
					pagesize: 10,
					page: 1,
					total: 0,
					list: [],
				},
				check_list: [],
				
				tableColumn: [
					{
						width: 500,
						prop: 'name',
						name: '产品单位名称',
					},
					{
						prop: 'sort',
						name: '排序',
					},
					{
						width: 200,
						name: '操作',
					},
				],
			}
		},
		created() {
			this.fn_Resets()
		},
		watch: {
			dialogshow(){
				if(!this.dialogshow) {
					this.dialoginfo = {
						name: '',
						sort: '',
					}
					this.edit_id = ''
					this.edit_flag = false
				}
			},
		},
		methods: {
			// 批量按钮点击
			custom_click(index) {
				let list = this.check_list
				if (list.length > 0) {
					let newArr = []
					for (let item of list) { 
						newArr.push(item.unit_id)
					}
					if (index == 1) { // 删除 
						this.fn_delrecord(newArr.join(','))
					}
				}
			},
			deldata(row){
				this.fn_delrecord(row.unit_id)
			},
			fn_delrecord(ids){
				// unit_id
				this.$confirm('您确定要删除吗?')
					.then(() => {
						del_goods_unit(ids).then(res=>{
							if(handlereq(res)) {
								alertMess('删除成功')
								this.fn_Resets()
							}
						})
					}).catch(() => {});
			},
			editdata(row){
				if(row) {
					this.edit_flag = true
					this.dialoginfo.name = row.name || '';
					this.dialoginfo.sort = row.sort ;
					this.edit_id = row.unit_id
					this.dialogshow = true 
					this.dialogtitle= '编辑产品单位'
				}
				else {
					alertMess('数据不存在','error')
				}
			},
			adddata(){
				this.edit_flag = false
				this.dialogshow = true
				this.dialogtitle= '添加产品单位'
			},
			
			
			category_save(){
				
				let name = (this.dialoginfo.name + '').trim()
				let sort = this.dialoginfo.sort
				if(!name) {
					alertMess('请输入产品单位', 'error')
				}
				else {
					let data = {
						name,
						sort: sort ? sort : 100,
					}
					if(this.edit_flag) {  // 修改
						data.unit_id = this.edit_id || ''
						edit_goods_unit(data).then(res=>{
							if(handlereq(res)) {
								alertMess('修改成功')
								this.dialogshow = false
								this.fn_Resets()
							}
						})
					}
					else {   // 添加
						add_goods_unit(data).then(res=>{
							if(handlereq(res)) {
								alertMess('添加成功')
								this.dialogshow = false
								this.fn_Resets()
							}
						})
					}
				}
			},
			
		
			category_close(){
				this.dialogshow = false
			},
			fn_Resets() {
				this.datapage.page = 1
				this.datapage.pagesize = 20
				this.getdatalist()
			},
			
			getdatalist(){
				this.table_loading = true 
				let data = {
					pagesize: this.datapage.pagesize, //  	是	int	每页数量
					page: this.datapage.page,
				}
				
				get_goods_unit_list(data).then(res=>{
					if(handlereq(res)) {
						let obj = res.result.data
						this.handle_data(obj)
						this.datapage.total = res.result.total
						this.table_loading = false
					}
				})
				
			},
			
			// 处理数据
			handle_data(data) {
				if (data) {
					this.datapage.list = data
				}
			},
			//
			modify_pagesize(e) {
				let {
					val
				} = e
				this.datapage.page = 1
				this.datapage.pagesize = val
				this.getdatalist()
			},
			switch_page(e) {
				let {
					val
				} = e
				this.datapage.page = val
				this.getdatalist()
			},
		},
	}
</script>

<style lang="scss" scoped>
	.nav_box{
		width: 100%;
		background-color: #fff;
		margin-bottom: 10px;
		padding: 10px;
		/deep/ .el-button{
			background-color: var(--themeColors);
			color:#fff;
			border: none;			
		}
	}
	.table_box{
		width: 100%;
		background-color: #fff;
		padding: 10px 5px;
	}
	.Viewspan{
		cursor: pointer;
		color: var(--themeColors);
		margin-right: 10px;
	}
	.delspan{
		cursor: pointer;
		color: #ff215c;
	}
	.version {
	    position: absolute;
	    min-width: 958px;
	    padding: 0;
	    padding-bottom: 10px;
	    margin-top: 60px;
	    padding-right: 10px;
	    right: 0;
	    left: 160px;
	}
	/deep/ .el-date-editor .el-input__inner{
		padding: 0 32px !important;
	}
	/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
		width: 100% !important;
	}
	
</style>